import React, {useEffect, useRef, useState} from "react";
import Calendar, {today} from "./Calendar";
import {useQuery} from "react-query";
import {getResult} from "../redux/core/_requests";
import ResultTable from "./ResultTable";
import {getDefDate} from "../helper/dateUtils";


const ResultWrapper = () => {
    const [filterByDate, setFilterDate] = useState(today);
    const loaded = useRef(0);

    const {data} = useQuery({
        queryKey: ['history-result', filterByDate],
        queryFn: () => getResult({filterByDate})
    });

    useEffect(() => {
        if (data) {
            const date = getDefDate(data[0].drawAt);
            (loaded.current === 0 && filterByDate !== date) && setFilterDate(date)
            loaded.current += 1;
        }
        // eslint-disable-next-line
    }, [data]);


    return <>
        <div>
            <h1 className="heading">លទ្ធផលឆ្នោតខ្មែរ</h1>
            <Calendar date={filterByDate} onChangeDate={setFilterDate}/>
        </div>
        <ResultTable filterByDate={filterByDate} results={data ?? []}/>
    </>
}

export default ResultWrapper;